import styled from "styled-components";

const CopyButton = styled.img `
    position: absolute;
    right: 8px;
    height: 50%;
    top:23%;
`;

export default CopyButton;